/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:19:52
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title11 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P11 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = '2px solid #000';
    return tableColumns.map(({ children, ...item }) => {
      return {
        ...item,
        ...(Array.isArray(children) && { children: this.fillColor(children) }),
        style: {
          ...item.style,
          fontSize: 14,
          fontWeight: 500,
          textAlign: 'center',
          background: '#fff',
          color: '#000',
          borderRight: border,
          borderBottom: border,
          whiteSpace: 'nowrap',
        },
        colStyle: {
          fontSize: 14,
          fontWeight: 500,
          textAlign: 'center',
          borderRight: border,
          borderBottom: border,
        }
      }
    })
  }


  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title11 pageNumber="4.6">媒介渠道分类对比-<span className={s.titleHite}>按媒体源</span></Title11>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              按照媒体源划分媒介渠道，贡献度最高的是自媒体中的大众媒体，其次为资讯媒体中的IT科技媒体与行业媒体；可见，Vidda品牌的行业属性较高，专业人士或者兴趣圈内的用户倾向于发表观点和看法，相关内容如产品的测评介绍、体验分享、推广种草贡献较大。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <Chart isShow options={setChart({ title: chartTitle, list: chartList, color: chartColorList })} />
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{
                    borderTop: `2px solid #000`,
                    borderLeft: `2px solid #000`,
                  }}
                />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P11);



// WEBPACK FOOTER //
// src/routes/visualChart/P11/index.js